import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class BaseService {
  constructor(protected readonly httpClient: HttpClient) {}
}
